/* eslint-disable */

import { ApiClient } from '../apiClient';

export type NewsletterStatus = 'SUBSCRIBED' | 'UNSUBSCRIBED';

export interface NewsletterSubscription {
    email: string;
    name?: string;
    status: NewsletterStatus;
    subscribedAt?: string;
}

export class NewsletterService {
    constructor(private apiClient: ApiClient) { }

    /**
     * Subscribe to the newsletter
     */
    async subscribe(email: string): Promise<any> {
        return await this.apiClient.post('contact/newsletter', { email });
    }

    /**
     * Manage-page endpoints - authenticated by the signed token from the
     * manage link (email + token query params), no user session required.
     */
    async getSubscription(email: string, token: string): Promise<NewsletterSubscription> {
        return await this.apiClient.post('contact/newsletter/status', { email, token });
    }

    async unsubscribe(email: string, token: string): Promise<NewsletterSubscription> {
        return await this.apiClient.post('contact/newsletter/unsubscribe', { email, token });
    }

    async resubscribe(email: string, token: string): Promise<NewsletterSubscription> {
        return await this.apiClient.post('contact/newsletter/resubscribe', { email, token });
    }

    /**
     * Account-section endpoints - authenticated by the user session (cookies);
     * the backend acts on the logged-in user's email, no token needed.
     */
    async getAccountSubscription(): Promise<NewsletterSubscription> {
        return await this.apiClient.get('contact/newsletter/account');
    }

    async accountSubscribe(): Promise<NewsletterSubscription> {
        return await this.apiClient.post('contact/newsletter/account/subscribe', {});
    }

    async accountUnsubscribe(): Promise<NewsletterSubscription> {
        return await this.apiClient.post('contact/newsletter/account/unsubscribe', {});
    }

    /**
     * Verify email subscription
     */
    async verifyEmail(email: string | null, token: string | null): Promise<any> {
        if (!email || !token) {
            return {
                success: false,
                message: 'Invalid verification link. Please try subscribing again.'
            };
        }

        try {
            const response = await this.apiClient.get<any>(
                `/verify?email=${encodeURIComponent(email)}&token=${encodeURIComponent(token)}`
            );
            return response;
        } catch (error) {
            return {
                success: false,
                message: 'Failed to verify email. The link might have expired. Please try subscribing again.'
            };
        }
    }
}
